import { phoneFormat, removePhoneFormat } from '@src/services/utils'
import { ReactNode, useId } from 'react'
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'

interface Props<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  label: ReactNode
  className?: string
}

const PhoneInput = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  className,
}: Props<TFieldValues>) => {
  const id = useId()
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => {
        return (
          <div className={`control-group ${className} ${invalid && 'error'}`}>
            <label htmlFor={id}>{label}</label>
            <div className="phone-input-wrapper">
              <input
                {...field}
                id={id}
                type="text"
                inputMode="numeric"
                className="phone-input"
                placeholder="( ___ ) ___-____"
                value={phoneFormat(value)}
                onChange={(e) => onChange(removePhoneFormat(e.target.value))}
              />
              <span className="phone-input-decorator">+1</span>
            </div>
            {error?.message && error.type !== 'required' && <p className="error-message">{error.message}</p>}
          </div>
        )
      }}
    />
  )
}

export default PhoneInput
